import { render, staticRenderFns } from "./TableFilter.vue?vue&type=template&id=00670df4&scoped=true"
import script from "./TableFilter.vue?vue&type=script&lang=js"
export * from "./TableFilter.vue?vue&type=script&lang=js"
import style0 from "./TableFilter.vue?vue&type=style&index=0&id=00670df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00670df4",
  null
  
)

export default component.exports